const encerrar_o_ano_letivo_das_turmas_e_gerar_o_historico_escolar_dos_alunos =
  [
    {
      path: "/encerrar-o-ano-letivo-das-turmas-e-gerar-o-historico-escolar-dos-alunos",
      name: "encerrar_o_ano_letivo_das_turmas_e_gerar_o_historico_escolar_dos_alunos",
      meta: {
        allowedPermissions: [
          "relatoriofinal_arquivar",
          "relatoriofinal_buscar",
        ],
        breadCrumb: "Processo de Resultado Final - Encerramento do Ano Letivo",
      },
      component: () =>
        import(
          "@/views/EncerrarOAnoLetivoDasTurmasEGerarOHistoricoEscolarDosAlunos/EncerrarOAnoLetivoDasTurmasEGerarOHistoricoEscolarDosAlunos.vue"
        ),
    },
  ];

export { encerrar_o_ano_letivo_das_turmas_e_gerar_o_historico_escolar_dos_alunos };
